import { toast } from "react-toastify"
import { digitalManagerApi } from "../../services/api"
import { queryClient } from "../../services/queryClient"

export async function deleteEntity(url: string) {
  try {
    await digitalManagerApi.delete(url)
    toast.success("Item deleted")
    await queryClient.invalidateQueries()
  } catch {
    toast.error("Cannot delete item")
  }
}
